module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"新着解析結果"},"en":{"title":"Recent"}}')
  delete Component.options._Ctor
}
